import { useLocation, useNavigate, Link } from "react-router-dom";
import { FiGrid, FiTag, FiImage, FiHome, FiUsers, FiMessageSquare, FiLogOut } from "react-icons/fi";
import { useDispatch } from "react-redux";
import { logoutSuccess } from "../../../redux/authRedux";
import Swal from "sweetalert2";
import CherryK from "../../../assets/img/cherryk.png";
import "./sidebar.css";

const navItems = [
  { path: "/treatment-dashboard", match: "/treatment", icon: <FiGrid />, label: "Treatments (Blog)" },
  { path: "/cms-treatment", match: "/cms-treatment", icon: <FiGrid />, label: "Treatment Types" },
  { path: "/promotion", match: "/promotion", icon: <FiTag />, label: "Promotions" },
  { path: "/banner", match: "/banner", icon: <FiImage />, label: "Banner" },
  { path: "/branch", match: "/branch", icon: <FiHome />, label: "Branches" },
  { path: "/staff", match: "/staff", icon: <FiUsers />, label: "Staff" },
  { path: "/testimonial", match: "/testimonial", icon: <FiMessageSquare />, label: "Testimonials" },
];

function SideBar() {
  const location = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const logout = () => {
    Swal.fire({
      title: "Success",
      text: "successfully Logout!",
      icon: "success",
      showConfirmButton: false,
      timer: 2000,
    }).then(function () {
      dispatch(logoutSuccess());
      navigate("/");
    });
  };

  return (
    <aside className="ws-sidebar">
      <div className="ws-sidebar-logo">
        <img src={CherryK} alt="Cherry-K" />
      </div>

      <nav className="ws-sidebar-nav">
        {navItems.map((item) => (
          <Link
            key={item.path}
            to={item.path}
            className={"ws-sidebar-link" + (location.pathname.startsWith(item.match) ? " active" : "")}
          >
            {item.icon}
            <span>{item.label}</span>
          </Link>
        ))}
      </nav>

      <div className="ws-sidebar-footer">
        <button className="ws-sidebar-logout" onClick={logout}>
          <FiLogOut />
          <span>Logout</span>
        </button>
      </div>
    </aside>
  );
}

export default SideBar;
